import { Exception } from "./Exception";
import { HttpError } from "./HttpError";
import * as _ from "lodash";

/**
 * Excessão de erros HTTP.
 *
 * @author Highlander Paiva
 * @since 1.0
 */
export const HttpException = {
  /**
   * Retorna um objeto erro dada a resposta.
   *
   * @param response A resposta HTTP
   * @param show A flag que dita se o erro será ou não exportado ao
   *             usuário
   * @return {*|void} O erro
   */
  init(response, show = false) {
    return handleError(response, show);
  }
};

function isFieldErrorMap(data) {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return false;
  }
  if (
    Object.prototype.hasOwnProperty.call(data, "message") &&
    typeof data.message === "string" &&
    Object.keys(data).length === 1
  ) {
    return false;
  }
  const keys = Object.keys(data);
  if (keys.length === 0) {
    return false;
  }
  return keys.every(k => typeof data[k] === "string");
}

function formatFieldErrorMap(data) {
  return [...new Set(Object.values(data))].join("\n");
}

/**
 * Retorna um objeto erro com o devido status e
 * mensagem.
 *
 * @param response A resposta HTTP
 * @param show A flag que dita se o erro será ou não exportado ao usuário
 * @return {{message: (*|string)}}
 */
function handleError(response, show) {
  if (valid(response)) {
    const status = response.response.status;
    const data = response.response.data;
    let fieldErrors = null;
    let msg = generateMessage(response);

    if (status === 400 && isFieldErrorMap(data)) {
      fieldErrors = { ...data };
      if (msg == null) {
        msg = formatFieldErrorMap(data);
      }
    }

    if (msg !== null || fieldErrors) {
      return Exception({
        message: msg != null ? msg : formatFieldErrorMap(data),
        show,
        status,
        fieldErrors
      });
    }
    return Exception({ show, status });
  } else {
    return new Error("Argumentos inválidos de Exceção.");
  }
}

/**
 * Confere se o status é previsto no helper de erros
 * comparando se a mensagem entregue por parâmetro
 * é null ou undefined e retornando falso pra caso seja.
 *
 * @param statusMsg O status da mensagem
 * @return {Boolean} Verdadeiro se existir a mensagem tratada
 * no {HttpError}.
 */
function handledHttpError(statusMsg) {
  return !_.isNil(HttpError[statusMsg]);
}

/**
 * Dado o erro HTTP, retorna a mensagem correta
 * de acordo com seu status, guardado em HttpError ou
 * disponibilizado pelo backend.
 *
 * @param error
 * @return {String | null}
 */
function generateMessage(error) {
  let status = error.response.status;
  let data = error.response.data;

  if (handledHttpError(status)) {
    return HttpError[status];
  }

  if (status === 400 && isFieldErrorMap(data)) {
    return formatFieldErrorMap(data);
  }

  if (!_.isNil(data.message)) {
    return data.message;
  }
  if (typeof data === "string") {
    return data;
  }
  return null;
}

/**
 * Checa se os argumentos do HttpException são
 * válidos.
 *
 * @param error A response de erro
 * @return verdadeiro se a response estiver como esperada
 */
function valid(error) {
  return error && error.response && error.response.data;
}
